// NOTE: styles are imported in frontend.scss
// because they didn't work being imported here

import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player';

window.VidstackPlayer = VidstackPlayer;
window.VidstackPlayerLayout = VidstackPlayerLayout;
